import React from 'react'
import { connect } from 'react-redux'

import Button from './UI/Button'

import lowNotes from '../constants/lowNotes'
import tooltips from '../constants/tooltips.json'

import { changeLowNote } from '../actions/presetParamBarActions'

const BarLowNote = (props) => {
  let {
    lowNote,
    onLowNoteChange,
    showTooltips
  } = props

  return (
    <div
      className="low-note-shift"
      data-tip={tooltips['editor-low-note']}
      data-multiline="true"
      data-place="right"
      data-tip-disable={!showTooltips}
      >
      <label>Low Note</label>
      <Button name="low-note-down" kind="arrow-left" value={-1} onClick={ () => onLowNoteChange(-1) } />
      <div className="low-note">{ lowNotes[lowNote] }</div>
      <Button name="low-note-up" kind="arrow-right" value={1} onClick={ () => onLowNoteChange(1) } />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    lowNote: state.currentPreset.lowNote,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLowNoteChange: (value) => {
      dispatch(changeLowNote(value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BarLowNote)
